import { useState, useEffect } from 'react';

const projectCards = [
  {
    img: '/images/ref1.jpg',
    alt: 'Sondermaschinen & Anlagen – gowiTEC Referenzprojekt',
    category: 'Sondermaschinen & Anlagen',
    description: 'Individuelle Montageanlagen, automatisierte Fertigungssysteme und Sondermaschinen nach Kundenanforderung.',
    featured: true,
  },
  {
    img: '/images/ref2.jpg',
    alt: 'Automatisierung & Handling – gowiTEC Referenzprojekt',
    category: 'Automatisierung & Handling',
    description: 'Fördertechnik, Transfersysteme, pneumatische und elektrische Systeme sowie automatisierte Abläufe.',
    featured: true,
  },
  {
    img: '/images/ref3.jpg',
    alt: 'Steuerungstechnik & SPS – gowiTEC Referenzprojekt',
    category: 'Steuerungstechnik & SPS',
    description: 'Schaltschrankbau, SPS-Steuerungen, Anlagenintegration, Inbetriebnahme und Optimierung.',
    featured: false,
  },
  {
    img: '/images/ref4.jpg',
    alt: 'Projektumsetzung – gowiTEC Referenzprojekt',
    category: 'Projektumsetzung',
    description: 'Echte Bilder aus realisierten Anlagen und technischen Anwendungen – von der Idee bis zur Inbetriebnahme.',
    featured: false,
  },
  {
    img: '/images/ref5.jpg',
    alt: 'Maschinenbau Detail – gowiTEC Referenzprojekt',
    category: 'Sondermaschinen & Anlagen',
    description: 'Detailansicht einer realisierten Sondermaschine – präzise Mechanik und durchdachte Konstruktion.',
    featured: false,
  },
  {
    img: '/images/anlage2.jpg',
    alt: 'Automatisierte Anlage – gowiTEC',
    category: 'Automatisierung & Handling',
    description: 'Vollautomatische Anlage für Montage, Prüfung und Produktion – individuell auf den Kundenprozess abgestimmt.',
    featured: false,
  },
  {
    img: '/images/panel.jpg',
    alt: 'Bedienpanel – gowiTEC SPS',
    category: 'Steuerungstechnik & SPS',
    description: 'Modernes Bedienpanel mit HMI-Visualisierung für eine vollautomatische Produktionsanlage.',
    featured: false,
  },
  {
    img: '/images/schrank1.jpg',
    alt: 'Beckhoff SPS Schaltschrank – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    description: 'Professioneller Schaltschrankbau mit Beckhoff TwinCAT SPS – sauber verdrahtet und normgerecht ausgeführt.',
    featured: false,
  },
  {
    img: '/images/detail1.jpg',
    alt: 'Maschinendetail – gowiTEC',
    category: 'Sondermaschinen & Anlagen',
    description: 'Detailaufnahme einer Sondermaschine – hochwertige Verarbeitung und präzise Mechanik.',
    featured: false,
  },
  {
    img: '/images/sps1.jpg',
    alt: 'SPS und Steuerungstechnik – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    description: 'SPS-Steuerung und Verdrahtung für eine komplexe Automatisierungsanlage.',
    featured: false,
  },
  {
    img: '/images/sps2.jpg',
    alt: 'Steuerungstechnik Schaltschrank – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    description: 'Schaltschrankbau und Systemintegration – zuverlässige Steuerungstechnik für industrielle Anwendungen.',
    featured: false,
  },
  {
    img: '/images/hero-start.jpg',
    alt: 'Automatisierte Anlage gowiTEC',
    category: 'Automatisierung & Handling',
    description: 'Sondermaschine und individuelle Anlage für Montage, Prüfung und Produktion.',
    featured: false,
  },
];

const categories = ['Alle', 'Sondermaschinen & Anlagen', 'Automatisierung & Handling', 'Steuerungstechnik & SPS', 'Projektumsetzung'];

const partners = [
  {
    name: 'OMRON',
    role: 'Partner',
    description: 'Als OMRON Partner programmieren und integrieren wir OMRON Sysmac SPS-Systeme (NJ / NX) in komplexe Automatisierungsanlagen – zuverlässig, präzise und zukunftssicher.',
  },
  {
    name: 'Loxone',
    role: 'Partner',
    description: 'Als Loxone Partner realisieren wir intelligente Gebäudeautomation und Sicherheitstechnik für Gewerbe- und Industriegebäude – energieeffizient und zuverlässig.',
  },
];

const CompanyPartners = () => {
  const [activeCategory, setActiveCategory] = useState('Alle');
  const [lightbox, setLightbox] = useState<{ img: string; alt: string } | null>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightbox(null);
    };
    if (lightbox) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [lightbox]);

  const filtered = activeCategory === 'Alle'
    ? projectCards
    : projectCards.filter((p) => p.category === activeCategory);

  const featured = filtered.slice(0, 2);
  const rest = filtered.slice(2);

  return (
    <>
      {/* Referenzprojekte */}
      <section className="py-24 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">

          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
            <div>
              <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Referenzen</span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-3">
                Einblicke in unsere Projekte
              </h2>
              <p className="text-gray-500 text-base max-w-xl leading-relaxed">
                Über 500 realisierte Projekte in Maschinenbau, Steuerungstechnik und Automation –
                hier ein Auszug mit echten Fotos aus unseren Projekten.
              </p>
            </div>
            {/* Zähler */}
            <div className="shrink-0 bg-[#1E3A8A] text-white rounded-xl px-7 py-5 text-center hidden md:block">
              <div className="text-3xl font-bold">500+</div>
              <div className="text-blue-200 text-xs mt-1">Projekte realisiert</div>
            </div>
          </div>

          {/* Filter Tabs */}
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeCategory === cat
                    ? 'bg-[#1E3A8A] text-white'
                    : 'bg-white border border-gray-200 text-gray-600 hover:border-[#1E3A8A] hover:text-[#1E3A8A]'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Featured Row – 2 große Bilder */}
          {featured.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
              {featured.map((project) => (
                <div
                  key={project.img + 'featured'}
                  className="group relative w-full h-[300px] rounded-xl overflow-hidden cursor-pointer bg-gray-100"
                  onClick={() => setLightbox({ img: project.img, alt: project.alt })}
                >
                  <img
                    src={project.img}
                    alt={project.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="inline-block text-[#DC2626] text-xs font-semibold tracking-widest uppercase mb-1">
                      {project.category}
                    </span>
                    <p className="text-white text-sm leading-relaxed">{project.description}</p>
                  </div>
                  <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-zoom-in-line text-white text-sm"></i>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Rest – kleineres Grid */}
          {rest.length > 0 && (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
              {rest.map((project) => (
                <div
                  key={project.img + project.category}
                  className="group relative w-full h-[160px] rounded-xl overflow-hidden cursor-pointer bg-gray-100"
                  onClick={() => setLightbox({ img: project.img, alt: project.alt })}
                >
                  <img
                    src={project.img}
                    alt={project.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-8 h-8 flex items-center justify-center bg-white/90 rounded-full">
                      <i className="ri-zoom-in-line text-[#1E3A8A] text-sm"></i>
                    </div>
                  </div>
                  {/* Kategorie-Tooltip unten */}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <span className="text-white text-xs font-medium leading-tight line-clamp-1">{project.category}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Hinweis */}
          <div className="bg-white border-l-4 border-[#1E3A8A] rounded-r-xl px-6 py-5">
            <p className="text-gray-600 text-sm leading-relaxed">
              <strong className="text-gray-800">Hinweis:</strong> Viele Projekte werden kundenspezifisch umgesetzt
              und unterliegen Vertraulichkeit. Daher werden bewusst keine detaillierten Projektdaten oder
              Kundennamen veröffentlicht.
            </p>
          </div>
        </div>
      </section>

      {/* Partner */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Partner</span>
            <h2 className="text-3xl font-bold text-gray-900 mt-3 mb-4">Unsere Partnerschaften</h2>
            <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
              Durch starke Partnerschaften erweitern wir unser Leistungsangebot und bieten Ihnen zertifizierte Lösungen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* OMRON */}
            <div className="bg-[#F8FAFC] rounded-xl border border-gray-100 p-8 flex flex-col sm:flex-row gap-6 items-start">
              <div className="w-36 h-16 flex items-center justify-center bg-white rounded-lg border border-gray-100 shrink-0 px-4 py-3">
                <img
                  src="https://storage.readdy-site.link/project_files/0c485b57-fedb-40d8-8940-c50727e75c3c/9668503a-dcd7-40d6-8bc5-9e13acd0327c_Omron-logo.jpg?v=c9c44afe4a42e3aac7d26ed2abc7929b"
                  alt="OMRON Logo"
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
              <div>
                <div className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase mb-1">Partner</div>
                <h3 className="text-gray-900 font-bold text-xl mb-2">OMRON</h3>
                <p className="text-gray-500 text-sm leading-relaxed">Als OMRON Partner programmieren und integrieren wir OMRON Sysmac SPS-Systeme (NJ / NX) in komplexe Automatisierungsanlagen – zuverlässig, präzise und zukunftssicher.</p>
              </div>
            </div>
            {/* Loxone */}
            <div className="bg-[#F8FAFC] rounded-xl border border-gray-100 p-8 flex flex-col sm:flex-row gap-6 items-start">
              <div className="w-36 h-16 flex items-center justify-center bg-white rounded-lg border border-gray-100 shrink-0 px-4 py-3">
                <img
                  src="https://storage.readdy-site.link/project_files/0c485b57-fedb-40d8-8940-c50727e75c3c/cc570193-fe66-4bb7-9cb1-bc7bef89adab_loxo_partner.jpg?v=13213c94cd01057b5d8c1ee02d9584e3"
                  alt="Loxone Logo"
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
              <div>
                <div className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase mb-1">Partner</div>
                <h3 className="text-gray-900 font-bold text-xl mb-2">Loxone</h3>
                <p className="text-gray-500 text-sm leading-relaxed">Als Loxone Partner realisieren wir intelligente Gebäudeautomation und Sicherheitstechnik für Gewerbe- und Industriegebäude – energieeffizient und zuverlässig.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-6 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={() => setLightbox(null)}
            aria-label="Lightbox schließen"
          >
            <i className="ri-close-line text-xl" aria-hidden="true"></i>
          </button>
          <img
            src={lightbox.img}
            alt={lightbox.alt}
            className="max-w-full max-h-[85vh] rounded-xl object-contain"
            loading="lazy"
            onClick={(e) => e.stopPropagation()}
          />
          <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/60 text-sm whitespace-nowrap">
            {lightbox.alt}
          </p>
        </div>
      )}
    </>
  );
};

export default CompanyPartners;
